/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbMobileRefineMenuFilterDeliveryOptions_viewer$ref = any;
type SbRespRefineMenuFilterDeliveryOptions_viewer$ref = any;
type SbSharedRefineMenuFilterCreator_viewer$ref = any;
type SbSharedRefineMenuFilterMaterial_viewer$ref = any;
type SbSharedRefineMenuFilterMetal_viewer$ref = any;
type SbSharedRefineMenuFilterOrigin_viewer$ref = any;
type SbSharedRefineMenuFilterStone_viewer$ref = any;
export type SbSharedRefineMenuFilters_viewer$ref = any;
export type SbSharedRefineMenuFilters_viewer = {
    readonly isMatchedSetsEnabled: boolean | null;
    readonly " $fragmentRefs": SbSharedRefineMenuFilterMetal_viewer$ref & SbSharedRefineMenuFilterStone_viewer$ref & SbSharedRefineMenuFilterOrigin_viewer$ref & SbSharedRefineMenuFilterCreator_viewer$ref & SbSharedRefineMenuFilterMaterial_viewer$ref & SbRespRefineMenuFilterDeliveryOptions_viewer$ref & SbMobileRefineMenuFilterDeliveryOptions_viewer$ref;
    readonly " $refType": SbSharedRefineMenuFilters_viewer$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuFilters_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isMatchedSetsEnabled",
      "name": "isEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "key",
          "value": "enableMatchedSetsFacet"
        }
      ],
      "storageKey": "isEnabled(key:\"enableMatchedSetsFacet\")"
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterMetal_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterStone_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterOrigin_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterCreator_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterMaterial_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuFilterDeliveryOptions_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbMobileRefineMenuFilterDeliveryOptions_viewer",
      "args": null
    }
  ]
};
(node as any).hash = '2dc57cf96f2e7742f8da74be8158735a';
export default node;
